import HttpService from "./HttpService";

let disciplinaService = {

    buscarListaDeDisciplinas: () => {
        return HttpService.backApi.get('/disciplinas/all');
    }

};

export default disciplinaService;
